import styled from "styled-components";
import { Box, Heading, Text } from "@vinomofo/components";
import { COLORS } from "../../styles";
import { Button } from "../button";
import { trackEvent } from "../../utils/track-event";
import { navigate } from "gatsby";

const StyledButton = styled(Button)`
  @media (max-width: 1038px) {
    a {
      text-align: center;
      padding: 0 !important;
      white-space: nowrap;
    }
  }
`;

const StyledBoxHeading = styled(Box)`
  h3 {
    white-space: nowrap;
  }
`;

export const ReferAFriend = (): JSX.Element => {
  return (
    <Box
      width="100%"
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      py={4}
      gridColumnGap="15px"
      flexDirection={["row", "row", "row"]}
    >
      <StyledBoxHeading>
        <Heading
          as="h3"
          fontSize={["24px", 30, 48]}
          color={COLORS.white}
          fontFamily={"SF Pro"}
          fontWeight="500"
        >
          Invite a friend
        </Heading>
        <Box
          width={["100%"]}
          mt="5px"
          flexGrow={2}
          display={["block", "none", "none"]}
        >
          <Text
            fontSize={["14px", "16px", 21]}
            textAlign={["left"]}
            as="p"
            color={COLORS.mofoGold}
            fontFamily={"SF Pro"}
            fontWeight="400"
            lineHeight="1.2"
          >
            Refer a friend and you&apos;ll both get $25* off your next order
          </Text>
        </Box>
      </StyledBoxHeading>
      <Box
        width={["50%"]}
        flexGrow={2}
        ml={2}
        display={["none", "block", "block"]}
      >
        <Text
          fontSize={["14px", "16px", 21]}
          textAlign={["left"]}
          as="p"
          color={COLORS.mofoGold}
          fontFamily={"SF Pro"}
          fontWeight="400"
        >
          Refer a friend and you&apos;ll both get $25* off your next order
        </Text>
      </Box>
      <Box textAlign={"right"} flexGrow={1}>
        <StyledButton
          style={{
            padding: "10px 24px",
            fontSize: "14px",
            textDecoration: 0,
          }}
          backgroundColor={COLORS.almostWhite}
          color={COLORS.trueBlack}
          onClick={(e) => {
            e.preventDefault();
            trackEvent("Invite Clicked", {
              location: location?.pathname,
            });
            navigate("/account/invite-friends");
          }}
          borderColor={"white"}
          isCTA
        >
          Start Inviting
        </StyledButton>
      </Box>
    </Box>
  );
};
